import { Carousel, JoinDiscordSection, RadialGradient } from 'components'
import { AppPage } from 'interfaces'
import React from 'react'

import { ArrowRightIcon } from '@heroicons/react/solid'

import { wallOfLove } from '../assets/images'
import {
  JoinDiscordButton,
  JoinWhatsAppButton
} from '../components/CommunityButtons'
import { past_events } from '../data/community'

const CommunityPage: AppPage = () => {
  return (
    <div className="relative px-6 py-8 overflow-x-hidden">
      <section className="flex flex-col items-center my-12">
        <h1 className="text-4xl sm:text-5xl xl:text-6xl md:text-5xl font-bold text-center">
          Join our <span style={{ color: '#8080FF' }}>Community</span>
        </h1>

        <div className="text-center mt-6">
          <p className="text-xl">
            Become a member of our super awesome community and witness a
            learning ecosystem where curiosity is nurtured.
          </p>
          <p className="text-xl">
            Join our whatsapp channel making sure you get all the updates
          </p>
        </div>

        <div className="mt-6 flex flex-wrap gap-2 sm:gap-0 justify-center">
          <JoinDiscordButton />
          <JoinWhatsAppButton />
        </div>
      </section>

      <RadialGradient top="10%" right="-300px" />
      <RadialGradient top="35%" left="-300px" />
      <RadialGradient top="70%" right="-300px" />

      <section className="flex flex-col justify-center py-8">
        <div className="text-center">
          <h2 className="text-2xl sm:text-4xl font-bold">
            Checkout Our Wall of Love
          </h2>
          <p style={{ color: '#8080FF' }} className="text-2xl font-medium">
            See what our Students say
          </p>

          <div className="mt-10 w-full flex items-center justify-center z-10">
            <img src={wallOfLove.src} alt="wall-of-love" />
          </div>
        </div>
      </section>

      <JoinDiscordSection />

      <section className="pb-24">
        <div className="text-center flex flex-col items-center">
          <h2 className="text-2xl sm:text-4xl font-bold">
            Past <span className="text-primary">Events</span>
          </h2>
          <p className="mt-6 max-w-lg text-base text-xl">
            Expert sessions and workshops getting hands on all tech domains by
            best of the best in the industry
          </p>
        </div>

        <div className="mt-12 w-full max-w-screen-2xl mx-auto">
          <Carousel
            itemClassName="flex"
            loopDuration={3000}
            slidesPerView={1}
            breakpoints={[
              { breakpoint: 300, value: { slidesPerView: 1 } },
              { breakpoint: 600, value: { slidesPerView: 2 } },
              { breakpoint: 1200, value: { slidesPerView: 3 } },
              { breakpoint: 1500, value: { slidesPerView: 4 } }
            ]}>
            {past_events.map((event, idx) => (
              <div
                key={idx}
                className="mx-auto rounded-2xl max-w-xs flex flex-col">
                <img
                  src={event.image}
                  alt="event"
                  className="object-cover object-center rounded-tl-2xl rounded-tr-2xl"
                />
                <div className="flex flex-col flex-1 bg-white text-zinc-800 p-3 rounded-bl-2xl rounded-br-2xl">
                  <span className="text-xl font-semibold">
                    {event.eventName}
                  </span>
                  <span className="text-sm font-medium text-zinc-600 mt-2">
                    {event.speaker}
                  </span>
                </div>
              </div>
            ))}

            <div className="rounded-2xl bg-zinc-800 flex flex-col items-center justify-evenly text-center mx-auto">
              <div className="bg-zinc-500 p-3.5 rounded-1/2">
                <ArrowRightIcon className="h-6 w-6" />
              </div>
              <p className="w-3/4">
                for more fun events check out our{' '}
                <a
                  style={{ color: '#8080FF' }}
                  href="https://discord.gg/devsnest"
                  target="_blank"
                  rel="noreferrer">
                  Discord
                </a>
              </p>
            </div>
          </Carousel>
        </div>
      </section>
    </div>
  )
}

CommunityPage.layout = {
  pageClassName: 'max-w-full overflow-hidden mx-0'
}

CommunityPage.seo = {
  title: 'Community | Devsnest',
  description:
    'Become a member of the largest tech community, where you will find 17K+ techies actively work together on different projects every day.',
  canonical: 'https://devsnest.in/community',
  openGraph: {
    url: 'https://devsnest.in/community'
  }
}

export default CommunityPage
